
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-ship-2-line text-3xl text-white"></i>
              </div>
              <span className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
                MarAzul
              </span>
            </Link>
            <p className="text-teal-100 text-sm leading-relaxed mb-6">
              Tu mejor opción para renta de lanchas y yates en Veracruz. Experiencias náuticas inolvidables desde 2014.
            </p>
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Servicios</h4>
            <ul className="space-y-3">
              <li><a href="#servicios" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Paseos en Lancha</a></li>
              <li><a href="#servicios" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Renta de Yates</a></li>
              <li><a href="#servicios" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Pesca Deportiva</a></li>
              <li><a href="#servicios" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Eventos Especiales</a></li>
              <li><a href="#servicios" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Tours al Atardecer</a></li>
              <li><a href="#servicios" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Grupos Corporativos</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Información</h4>
            <ul className="space-y-3">
              <li><a href="#flota" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Nuestra Flota</a></li>
              <li><a href="#experiencias" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Experiencias</a></li>
              <li><a href="#contacto" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Reservaciones</a></li>
              <li><a href="#" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Preguntas Frecuentes</a></li>
              <li><a href="#" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Términos y Condiciones</a></li>
              <li><a href="#" className="text-teal-100 hover:text-white text-sm transition-colors cursor-pointer">Política de Privacidad</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start text-sm">
                <i className="ri-map-pin-line text-lg mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-teal-100">Marina Veracruz, Blvd. Manuel Ávila Camacho, Veracruz, Ver.</span>
              </li>
              <li className="flex items-center text-sm">
                <i className="ri-phone-line text-lg mr-3 flex-shrink-0"></i>
                <a href="tel:+522291578562" className="text-teal-100 hover:text-white transition-colors cursor-pointer">(229) 157-8562</a>
              </li>
              <li className="flex items-center text-sm">
                <i className="ri-time-line text-lg mr-3 flex-shrink-0"></i>
                <span className="text-teal-100">Lun - Dom: 8:00 AM - 8:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-teal-500 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-teal-100 text-sm">
              © 2024 MarAzul Veracruz. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-teal-100 hover:text-white text-sm transition-colors">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
